import "./main.css";
import "../public/assets/quest-navigation.css";
import { Header } from "./components/Header";
import { SiteFooter } from "./components/SiteFooter";
import { SeoHead } from "./components/SeoHead";
import { HomePage } from "./pages/HomePage";
import { LeaguePage } from "./pages/LeaguePage";
import { RegisterPage } from "./pages/RegisterPage";
import { LeagueVerificationPage } from "./pages/LeagueVerificationPage";
import { ActivitiesPage } from "./pages/ActivitiesPage";
import { MembersPage } from "./pages/MembersPage";
import { SponsorsPage } from "./pages/SponsorsPage";
import { ContactPage } from "./pages/ContactPage";
import { JobQuestRouter } from "./features/jobQuest/JobQuestRouter";

function isLeaguePath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/league";
}

function isRegisterPath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/league/register";
}

function isVerificationPath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/league/register/verify";
}

function isActivitiesPath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/activities";
}

function isMembersPath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/members";
}

function isSponsorsPath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/sponsors";
}

function isContactPath(pathname: string) {
  return pathname.replace(/\/+$/, "") === "/contact";
}

export function Main() {
  const leaguePage = isLeaguePath(window.location.pathname);
  const registerPage = isRegisterPath(window.location.pathname);
  const verificationPage = isVerificationPath(window.location.pathname);
  const activitiesPage = isActivitiesPath(window.location.pathname);
  const membersPage = isMembersPath(window.location.pathname);
  const sponsorsPage = isSponsorsPath(window.location.pathname);
  const contactPage = isContactPath(window.location.pathname);
  const jobQuestPage = /^\/job-quest(?:\/|$)/.test(window.location.pathname);

  return (
    <>
      <SeoHead />
      <Header />
      {jobQuestPage ? (
        <JobQuestRouter />
      ) : verificationPage ? (
        <LeagueVerificationPage />
      ) : registerPage ? (
        <RegisterPage />
      ) : leaguePage ? (
        <LeaguePage />
      ) : activitiesPage ? (
        <ActivitiesPage />
      ) : membersPage ? (
        <MembersPage />
      ) : sponsorsPage ? (
        <SponsorsPage />
      ) : contactPage ? (
        <ContactPage />
      ) : (
        <HomePage />
      )}
      <SiteFooter />
    </>
  );
}
